module.exports = __webpack_public_path__ + "img/3.b35a16c.webp";